module.exports = __webpack_public_path__ + "cb234f4f5ee00efd5fb4d6955915b3d0.png";